import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Observable, of, ReplaySubject} from "rxjs";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {IddTrainingTrainerService} from "../../../shared/services/idd-training-trainer.service";
import {IddTrainingTrainer} from "../../../shared/interface/idd-training-trainer";



@Component({
  selector: 'app-add-idd-trainings-trainer',
  templateUrl: './add-idd-trainings-trainer.component.html',
  styleUrls: ['./add-idd-trainings-trainer.component.scss']
})
export class AddIddTrainingsTrainerComponent implements OnInit, OnDestroy {
  @Input() iddTrainingTrainerObject?: IddTrainingTrainer;
  @Input() dialogRef?: MatDialogRef<AddIddTrainingsTrainerComponent>;
  @Input() iddTrainingTrainer?: Observable<IddTrainingTrainer>;
  @Output() closeModification = new EventEmitter<any>();

  iddTrainingsTrainerForm: FormGroup;
  firstNameControl: FormControl;
  lastNameControl: FormControl;
  educationControl: FormControl;
  experienceControl: FormControl;
  memoControl: FormControl;
  activeControl: FormControl;
  charCountEducation = 0;
  charCountExperience = 0;

  processingRequest = false;
  formErrors = {};

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private iddTrainingTrainerService: IddTrainingTrainerService,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.iddTrainingsTrainerForm = fb.group({
      firstName: this.firstNameControl = fb.control('', [Validators.required]),
      lastName: this.lastNameControl = fb.control('', [Validators.required]),
      education: this.educationControl = fb.control('', [Validators.required]),
      experience: this.experienceControl = fb.control('', [Validators.required]),
      active: this.activeControl = fb.control(true),
      memo: this.memoControl = fb.control(''),
    });

  }

  ngOnInit(): void {
    if (this.iddTrainingTrainer) {
      this.iddTrainingTrainer
        .pipe(takeUntil(this.destroyed$))
        .subscribe((iddTrainingTrainer: IddTrainingTrainer) => {
          this.iddTrainingTrainerObject = iddTrainingTrainer;
          this.initialize(iddTrainingTrainer);
        });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (!this.iddTrainingsTrainerForm.valid) {
      this.iddTrainingsTrainerForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.iddTrainingsTrainerForm, this.formErrors);
    this.formErrors = {};

    this.iddTrainingTrainerService.sendForm(this.iddTrainingsTrainerForm.getRawValue(), this.iddTrainingTrainerObject?.uuid)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.iddTrainingTrainerObject ? 'Pomyślnie zaktualizowano Szkoleniowca'
          : 'Pomyślnie utworzono Szkoleniowca', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.iddTrainingTrainer) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/szkolenie/szkoleniowcy/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open(this.iddTrainingTrainerObject ? 'Podczas aktualizacji Szkoleniowca wystąpił błąd'
          : 'Podczas tworzenia Szkoleniowca wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.iddTrainingsTrainerForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (this.iddTrainingTrainer) {
      this.closeModification.emit();
    } else {
      this.router.navigate(['/szkolenie/szkoleniowcy']);
    }
  }

  initialize(iddTrainingTrainer: IddTrainingTrainer): void {
    of(iddTrainingTrainer)
      .pipe(
        delay(0),
        tap(() => {
          this.iddTrainingsTrainerForm.reset({
            firstName: iddTrainingTrainer.firstName,
            lastName: iddTrainingTrainer.lastName,
            education: iddTrainingTrainer.education,
            experience: iddTrainingTrainer.experience,
            memo: iddTrainingTrainer.memo,
            active: iddTrainingTrainer.active,
          });
          this.updateCharCountExperience();
          this.updateCharCountEducation()
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }
  updateCharCountExperience(): void {
    this.charCountExperience = this.experienceControl.value ? this.experienceControl.value.length : 0;
  }
  updateCharCountEducation(): void {
    this.charCountEducation = this.educationControl.value ? this.educationControl.value.length : 0;
  }
}
